module.exports = __webpack_public_path__ + "static/img/gold1.d5b60eae.webp";